import { DelayButtonWrapper } from './style';
import { Tooltip, Typography } from '@mui/material';
import { colors } from 'crono-fe-common/theme';
import MinusSmallIcon from 'crono-fe-common/icons/Icon-Minus-Small';
import { FeConstants } from 'constants/FeConstants';
import PlusSmallIcon from 'crono-fe-common/icons/Icon-Plus-Small';
import React from 'react';
import { cn } from 'utils/style-utils';

interface IProps {
  delay: number;
  decreaseDelay: () => void;
  increaseDelay: () => void;
  dateLabel?: string;
  tooltipTitle?: string;
  delayLabel?: 'Wait:' | 'Today:';
  children?: React.ReactNode | React.ReactNode[];
  disabled?: boolean;
  isFirstStep?: boolean;
  showLabel?: boolean;
}

const DelayButton = ({
  delay,
  decreaseDelay,
  increaseDelay,
  dateLabel,
  tooltipTitle,
  delayLabel = 'Wait:', // when today we don't show the delay since its 0 and we can't edit it
  children,
  disabled = false,
  isFirstStep = false,
  showLabel = false,
}: IProps) => {
  const delayPicker = (
    <div
      className={cn('delay-picker delay-picker-light', {
        'delay-picker-disabled': disabled,
      })}
    >
      {!disabled && (
        <Typography
          className="delay-picker-button"
          onClick={decreaseDelay}
          style={{ display: 'inline-flex' }}
        >
          <MinusSmallIcon
            color={
              delay === FeConstants.MIN_DELAY || disabled
                ? colors.grey3
                : colors.grey11
            }
          />
        </Typography>
      )}

      <Typography fontSize={'12px'} fontWeight={500}>
        {`${delay} ${delay === 1 ? 'day' : 'days'}`}
      </Typography>

      {!disabled && (
        <Typography
          className="delay-picker-button"
          onClick={increaseDelay}
          style={{ display: 'inline-flex' }}
        >
          <PlusSmallIcon
            color={
              delay === FeConstants.MAX_DELAY || disabled
                ? colors.grey3
                : colors.grey11
            }
          />
        </Typography>
      )}
    </div>
  );

  const delayOptionContainer = (
    <div className="delay-option-container">
      {tooltipTitle ? (
        <Tooltip
          placement="top"
          title={tooltipTitle}
          arrow
          enterDelay={400}
          leaveDelay={400}
          componentsProps={{
            tooltip: {
              sx: {
                textAlign: 'center',
              },
            },
          }}
        >
          {delayPicker}
        </Tooltip>
      ) : (
        delayPicker
      )}
    </div>
  );

  return (
    <Tooltip
      title={'Weekend days are excluded'}
      arrow
      enterDelay={400}
      enterNextDelay={400}
    >
      <DelayButtonWrapper>
        {dateLabel || showLabel ? (
          <div
            className={cn('delay-container', {
              'delay-container--disabled': disabled,
            })}
          >
            {isFirstStep ? (
              <div className="delay-container__left-box">
                <Typography fontSize={12} lineHeight={'16px'} fontWeight={500}>
                  Start date
                </Typography>
                <Typography
                  fontSize={12}
                  lineHeight={'16px'}
                  color={colors.grey11}
                >
                  When the contact is enrolled
                </Typography>
              </div>
            ) : (
              <Typography fontSize={12} fontWeight={500}>
                {delayLabel}
              </Typography>
            )}

            {delayLabel === 'Today:' && disabled ? null : delayOptionContainer}

            {dateLabel && (
              <Typography
                className="step-date"
                fontSize={12}
                fontWeight={500}
                color={colors.grey11}
              >
                {dateLabel}
              </Typography>
            )}
            {children}
          </div>
        ) : (
          delayOptionContainer
        )}
      </DelayButtonWrapper>
    </Tooltip>
  );
};

export default DelayButton;
